import { useCallback } from 'react';

import type { CreateContentReportDto } from '@splitfiesta/shared';

import { openReportDialog } from '@/components/moderation/ReportDialog';

/**
 * Opens the app-wide report dialog (see ReportDialogHost) for a piece
 * of UGC. The dialog collects a required reason category + required
 * typed details and submits POST /content-reports itself — one hook so
 * every surface (comments, members, groups) reports identically.
 * Mirrors mobile's useReportContent.
 */
export function useReportContent() {
  return useCallback((input: CreateContentReportDto) => {
    openReportDialog(input);
  }, []);
}
